import React from 'react';
import ReactDOM from 'react-dom';
import KrModal from './components/okr/modals/kr-modal';
import GoalServices from './services/goal.services';
import { reactLoader, removeReactLoader } from './utils/common';
import { PageScrollVisible, SetKrContainerHeight } from './utils/function';

const openCasacdeKrModel = function (metricId, focus) {
  ReactDOM.render(
    <OpenKrModal metricId={metricId} onOpened={focus && focus.onOpened} onClosed={focus && focus.onClosed} />,
    document.getElementById('cascadeContent'),
  );
};

export default class OpenKrModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalProps: {},
      close:false
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.GoalServices = new GoalServices();
  }

  componentDidMount() {
    const _this = this;
    reactLoader();
    const params = {};
    params.metricId = this.props.metricId;
    params.cascadeReq = true;
    this.GoalServices.createCascadeDetails(params)
      .then((response) => {
        removeReactLoader();
        if (response.data) {
          if (_this.props.onOpened) _this.props.onOpened();
          _this.setState({ showModal: true, modalProps: response.data.data }, () => {
            PageScrollVisible();
            setTimeout(() => SetKrContainerHeight(), 0);
          });
        }
      });
  }

  componentWillUnmount() {
    // console.log("edit cascade KR close");
     if(!close){
        metricDataSaveAfterAjax($(this), this.props.metricId);
     }
    // console.log("edit cascade KR end");
  }

  handleCloseModal() {
    const onClosed = this.props.onClosed;
    this.setState({ showModal: false ,close:true}, () => {
      PageScrollVisible(true);
      ReactDOM.unmountComponentAtNode(document.getElementById('cascadeContent'));
      if (onClosed) onClosed();
    });
  }

  render() {
    return (
      this.state.showModal
                && <KrModal isOpen={this.state.showModal} handleCloseModal={this.handleCloseModal} data={this.state.modalProps} />
    );
  }
}
window.openCasacdeKrModel = openCasacdeKrModel;
